import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING, STAKE } from "./constants";
import { Backdrop, SceneTitle, glow } from "./shared";

const ACCOUNTS = [
  { name: "Acme Corp",     status: "😠 Angry",  x: 180,  y: 320, c: COLORS.neonRed },
  { name: "Globex Ltd",    status: "💰 Upsell", x: 500,  y: 280, c: COLORS.neonYellow },
  { name: "Initech",       status: "⏳ Renewal", x: 880,  y: 340, c: COLORS.neonOrange },
  { name: "Umbrella Inc",  status: "❓ Silent",  x: 1280, y: 300, c: COLORS.textMuted },
  { name: "Stark Ind",     status: "🔥 Churn",   x: 240,  y: 620, c: COLORS.neonRed },
  { name: "Wayne Enter",   status: "📞 Callback", x: 620,  y: 660, c: COLORS.neonCyan },
  { name: "Tyrell Corp",   status: "😠 Angry",   x: 1020, y: 650, c: COLORS.neonRed },
  { name: "Soylent",       status: "💰 Upsell",  x: 1420, y: 640, c: COLORS.neonYellow },
];

export const Scene08CSProblem: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();

  const fade = interpolate(frame, [durationInFrames - 30, durationInFrames], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  const titleAp = interpolate(spring({ frame, fps, config: SPRING.snappy }), [0, 1], [0, 1], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill style={{ background: COLORS.bg, opacity: fade, overflow: "hidden" }}>
      <Backdrop frame={frame} accent={STAKE.success} />

      <SceneTitle
        text="Customer Success"
        subtitle="Fifty accounts. Monday morning. Zero memory."
        color={STAKE.success}
        frame={frame}
        appear={titleAp}
      />

      {/* Scattered account cards */}
      <div style={{ position: "absolute", inset: 0, perspective: 1200 }}>
        {ACCOUNTS.map((a, i) => {
          const sp = spring({ frame: frame - 30 - i * 8, fps, config: SPRING.bouncy });
          const op = interpolate(sp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const sc = interpolate(sp, [0, 1], [0.4, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const jitter = Math.sin(frame * 0.05 + i * 1.3) * 10;
          const rot = Math.sin(frame * 0.02 + i * 0.9) * 4;
          const pulse = 1 + Math.sin(frame * 0.08 + i) * 0.02;
          return (
            <div key={a.name} style={{
              position: "absolute",
              left: a.x,
              top: a.y + jitter,
              width: 260,
              height: 150,
              opacity: op,
              transform: `scale(${sc * pulse}) rotate(${rot}deg) perspective(800px) rotateY(${Math.sin(frame * 0.01 + i) * 6}deg)`,
              transformStyle: "preserve-3d",
            }}>
              <div style={{
                width: "100%", height: "100%",
                background: `linear-gradient(135deg, ${a.c}20, ${COLORS.bgCard}ee)`,
                border: `2px solid ${a.c}88`,
                borderRadius: 14,
                padding: 18,
                boxShadow: `0 0 30px ${a.c}44, 0 12px 24px rgba(0,0,0,0.5)`,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}>
                <div style={{
                  fontSize: 22,
                  fontFamily: FONTS.heading,
                  fontWeight: 800,
                  color: COLORS.textPrimary,
                }}>{a.name}</div>
                <div style={{
                  fontSize: 18,
                  fontFamily: FONTS.mono,
                  color: a.c,
                  textShadow: glow(a.c),
                }}>{a.status}</div>
                <div style={{
                  fontSize: 12,
                  fontFamily: FONTS.mono,
                  color: COLORS.textMuted,
                  letterSpacing: 1,
                }}>LAST CONTACT: ???</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Question mark cloud in center */}
      <div style={{
        position: "absolute", top: 430, left: "50%",
        transform: "translateX(-50%)",
        fontSize: 180,
        opacity: interpolate(spring({ frame: frame - 120, fps, config: SPRING.gentle }), [0, 1], [0, 0.22], { extrapolateLeft: "clamp", extrapolateRight: "clamp" }),
        filter: "blur(2px)",
        color: COLORS.neonRed,
        textShadow: `0 0 100px ${COLORS.neonRed}`,
        pointerEvents: "none",
      }}>❓</div>

      {/* Bottom stat */}
      <div style={{
        position: "absolute", bottom: 60, left: 0, right: 0,
        textAlign: "center",
        opacity: interpolate(spring({ frame: frame - 180, fps, config: SPRING.gentle }), [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" }),
      }}>
        <div style={{
          fontSize: 38,
          fontFamily: FONTS.heading,
          fontWeight: 800,
          color: COLORS.neonRed,
          textShadow: glow(COLORS.neonRed, true),
        }}>
          Rebuilding every account story · from scratch · every week
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
